import { CalendarClock } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { formatDate } from "@/lib/date-utils";
import { cn } from "@/lib/utils";
import { getDueVehicleDeadlines } from "@/lib/vehicle-deadlines";
import {
  vehicleStatusLabels,
  type Vehicle,
  type VehicleStatus,
} from "@/hooks/useVehicles";

const statusClasses: Record<VehicleStatus, string> = {
  active: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200",
  in_service:
    "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200",
  out_of_service:
    "bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200",
};

export function VehicleStatusBadge({ status }: { status: VehicleStatus }) {
  return (
    <Badge className={statusClasses[status]}>
      {vehicleStatusLabels[status]}
    </Badge>
  );
}

/** MFK, service, vignette and insurance deadlines that are overdue or due soon */
export function VehicleDeadlineBadges({ vehicle }: { vehicle: Vehicle }) {
  return (
    <>
      {getDueVehicleDeadlines(vehicle).map((deadline) => (
        <Badge
          key={deadline.key}
          variant="outline"
          className={cn(
            "gap-1",
            deadline.state === "overdue"
              ? "border-red-500 text-red-600 dark:text-red-400"
              : "border-amber-500 text-amber-600 dark:text-amber-400",
          )}
          data-testid={`vehicle-deadline-${deadline.key}`}
        >
          <CalendarClock className="h-3 w-3" />
          {deadline.label} {deadline.state === "overdue" ? "overdue" : "due"}{" "}
          {formatDate(new Date(deadline.date))}
        </Badge>
      ))}
    </>
  );
}
